import React, { useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { FormBuilder } from '@tf/formbuilder'

import {
	CircleSpinner,
	CustomerForm,
	getLanguageLocale,
	getMarket,
	BoxInfo,
} from 'shared'
import { FormFactory } from 'shared/formBuilder/formFactory'
import { MspDispatchContext, MSP_ACTIONS } from 'shared/components/Multistep'

import { SddDispatchContext, SDD_ACTIONS } from '../SDDMultistepValues'
import { IBankInfoProps } from 'selfServicePortal/interfaces/i-api-sdd'

export const SDDCustomerInformationForm = () => {
	const { msp, dispatchMsp } = useContext(MspDispatchContext)
	const [sdd, dispatchSdd] = useContext(SddDispatchContext)

	const { t } = useTranslation()
	const [err, setErr] = useState<boolean>(false)
	const [loading, setLoading] = useState<boolean>(false)
	const [date, setDate] = useState<any>()

	const formSchema = FormFactory(
		CustomerForm.CustomerInformationFormSDD,
		{
			formName: 'customerInformationFormSdd',
			blockName: 'customerInformationFormSdd',
			market: getMarket(),
			locale: getLanguageLocale(),
			getDataUrl: '',
			validationErrorList: false,
			requiredMessage: t('ValidateRequired'),
			submitButtonText: 'Fortfahren zu den AGB',
		},
		sdd
	)

	useEffect(() => {
		dispatchSdd({
			type: SDD_ACTIONS.SET_DESCRIPTION,
			payload: {
				description: 'SDDCustomerInfoSubtitle',
			},
		})
		getDate()
	}, [dispatchSdd])

	function getDate() {
		let date = new Date().toLocaleDateString(getLanguageLocale())
		return setDate(date)
	}

	const proceed = (values: any) => {
		setLoading(true)

		if (values.customer.iban !== null && values.customer.iban !== '') {
			const bankInfoItem = sdd.bankInfoList.find(
				({ senderIban }: IBankInfoProps) =>
					senderIban === values.customer.iban
			)
			setErr(false)
			dispatchSdd({
				type: SDD_ACTIONS.SET_BANK_INFO,
				payload: {
					...sdd,
					debtorIban: values.customer.iban,
					debtorBic: bankInfoItem.senderBic,
				},
			})
			dispatchMsp({
				type: MSP_ACTIONS.SET_INDEX,
				payload: {
					...msp,
					index: msp.index + 1,
				},
			})
			window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth',
			})
			setLoading(false)
		} else {
			setErr(true)
			setLoading(false)
		}
	}

	return (
		<div className="sdd-customer-information">
			<div className="sdd-customer-overview">
				<div className="inner-box">
					<div className="sdd-info">
						<div>
							<div>{t('CurrentDate')}:</div>
							<div>{date}</div>
						</div>
						<div>
							<div>{t('CreditorId')}:</div>
							<div>SE41CCC5561581041</div>
						</div>
					</div>
					<div className="tf-address">
						TF Bank AB
						<br />
						Box 947
						<br />
						501 10 Borås <br />
						Sweden
					</div>
				</div>
			</div>
			{!loading && (
				<>
					<div className="sdd-customer-information-form">
						<FormBuilder
							formSchema={formSchema}
							apiError={undefined}
							showErrorsInForm={true}
							showSubmitButton={true}
							onSubmit={(values) => proceed(values)}
						/>
					</div>
					{err && <BoxInfo message={t('ErrorMsg')} css={'fail'} />}
					<div className="sdd-customer-information-proceed-text">
						<p>{t('SDDCustomerInformationText')}</p>
					</div>
				</>
			)}
			{loading && <CircleSpinner />}
		</div>
	)
}
